import IHTTPProvider from 'shared/domain/providers/IHTTPProvider';
import IStorageProvider from 'shared/domain/providers/IStorageProvider';

export default class RemoveSessionUseCase {
  constructor(
    private storageProvider: IStorageProvider,
    private httpProvider: IHTTPProvider,
  ) {}

  public async execute() {
    this.storageProvider.delete('AUTHENTICATION');
    this.httpProvider.setHeader('AUTHENTICATION', null);
  }
}
